module.exports = __webpack_public_path__ + "img/done-white.0bd6aab0.svg";